import { Checkbox, MenuItem } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Termsandconditions } from "./lib/Termsandconditions";
import DateFnsUtils from "@date-io/date-fns";
import React, { useEffect, useReducer, useState } from "react";
import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import CardComponent from "./lib/CardComponent";
import CustomizedDialogs from "../../customModal";
import { connect, useDispatch } from "react-redux";
import IntegrationReactSelect from "../../../forms/autoCompleteInput";
import { RadioButton } from "./lib/Radiobutton";
import { useHistory } from "react-router";
import {
  getNewPurchaseFundList,
  validateSubBroker,
  swpOptions,
  CalcSIPEnddt,
  storeSchemeDetails,
  getNav,
  getOtherSchemes,
  storeSchemeParams,
  submitSipDetails,
  clearingFirstTimeInvestorJourney,
  getCheckPanKotm,
  getCheckPanAotm,
  PurchaseSaveNominee
} from "../../../../store/actions";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  REGULAR,
} from "../../../../store/types";
import {
  INVESTMENT_FREQUENCY,
  SIP_DAY,
  PAYMENT_MODE,
} from "../../../../store/types";
import CustomLoader from "../../../forms/Loader";
import { format } from "date-fns";
const LummpsumSip = (props) => {
  const history = useHistory();
  const initialState = {
    Scheme: { value: "" },
    EUIN: { value: "" },
    Category: { value: "" },
    "SIP Day": { value: "" },
    Frequency: { value: "" },
    "SIP Period From": { value: "" },
    "SIP Period To": { value: "" },
    "No of Installments": { value: "" },
    "Sub Broker Code": { value: "" },
    "Sub ARN Code": { value: "" },
    MinimumAmount: "",
    MinimumLumpsumAmount: "",
    Amount: { value: "" },
    "Lumpsum Amount": { value: "" },
    MinimumInstallements: "",
    schemeList: [],
    euinList: [],
    sipDateList: [],
    frequencyList: [],
    CategoryList: [],
    planValue: "",
    optionValue: "",
    schemeValue: "",
    multiple: "",
    perpetualSip: false,
    "Mode of Registration": "",
    modeList: [],
    umrnList: [],
    "UMRN": { value: "" },
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );
  const InputFields = [
    [
      {
        name: "Category",
        type: "select",
        placeholder: "Select Category",
        isMandatory: true,
        listName: "CategoryList",
      },
    ],
    [
      {
        name: "Scheme",
        type: "Searchselect",
        placeholder: "Select Scheme",
        isMandatory: true,
        listName: "schemeList",
      },
    ],
    [
      {
        name: "Sub ARN Code",
        type: "number",
        placeholder: "Select Sub ARN Code",
        isMandatory: false,
      },
      {
        name: "Sub Broker Code",
        type: "number",
        placeholder: "Select Sub Broker Code",
        isMandatory: false,
      },
      {
        name: "EUIN",
        type: "Searchselect",
        placeholder: "Select EUIN",
        isMandatory: true,
        listName: "euinList",
      },
    ],
    [
      {
        name: "Frequency",
        type: "select",
        placeholder: "Select Frequency",
        isMandatory: true,
        listName: "frequencyList",
      },
    ],
    [
      {
        name: "Mode of Registration",
        type: "select",
        placeholder: "Select Mode",
        isMandatory: true,
        listName: "modeList",
      },
    ],
    [
      {
        name: "UMRN",
        type: "select",
        placeholder: "Select UMRN",
        listName: "umrnList",
        display:
        formValues["Mode of Registration"].value === "KOTM" ||
        formValues["Mode of Registration"].value === "AOTM"
          ? false
          : true,
        disabled:formValues.umrnList.length===1?true:false
      },
    ],
    [
      {
        name: "SIP Day",
        type: "select",
        placeholder: "Select SIP Day",
        isMandatory: true,
        listName: "sipDateList",
      },
    ],
    [
      {
        name: "No of Installments",
        type: "number",
        placeholder: !formValues.perpetualSip ? "" : "Perpetual SIP",
        isMandatory: true,
        disabled: !formValues.perpetualSip ? false : true,
      },
    ],
    [
      {
        name: "SIP Period From",
        type: "date",
        placeholder: "Start Date",
        isMandatory: true,
        disabled: true,
      },
      {
        name: "SIP Period To",
        type: "date",
        placeholder: "End Date",
        isMandatory: true,
        disabled: true,
      },
    ],
      
    [
      {
        name: "Perpetual SIP",
        type: "Perpetual",
      },
    ],
    [
      {
        name: "Amount",
        type: "number",
        isMandatory: true,
      },
    ],
    [
      {
        name: "Lumpsum Amount",
        type: "number",

        isMandatory: true,
      },
    ],
  ];
  const [dialog, setDialog] = useState({ open: false, appno: "" });
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const SIP_Date = formValues["SIP Day"].value;
  const Frequency = formValues["Frequency"].value;
  const setFrequencyList = async () => {
    const euinParams = { opt: INVESTMENT_FREQUENCY, fund: "189" };
    const euinResponse = await props.swpOptions(euinParams);
    const { Dtinformation } = euinResponse;
    const frequencyList = Dtinformation.map((item) => ({
      label: item.FrequencyID,
      value: item.FrequencyID,
      min: item.Minimum_Instalment,
    }));
    setFormValues({ frequencyList });
  };
  const handleScheme = (label) => (event) => {
    const { schemeList } = formValues;
    if (label === "Scheme") {
      const scheme = schemeList.find((item) => item.label === event.label);
      setFormValues({
        Scheme: { value: event },
        planValue: scheme.planValue,
        optionValue: scheme.optionValue,
        schemeValue: scheme.schemeValue,
        MinimumAmount: scheme.MinimumAmount,
        multiple: scheme.multiples || 1,
        MinimumLumpsumAmount: scheme.MinimumLumpsumAmount,
      });
    }
    if (label === "EUIN") {
      setFormValues({
        EUIN: { value: event },
      });
      setFrequencyList();
    }
  };
  const handleChange = (label) => async (event) => {
    const value = event.target.value;
    if (!value && label !== "Sub ARN Code" && label !== "Sub Broker Code") {
      setFormValues({
        [label]: {
          value,
          isError: true,
          errorMessage: `${label} is Mandatory`,
        },
      });
      return;
    }
    setFormValues({ [label]: { value } });
    switch (label) {
      case "Category":
        setFormValues({
          [label]: { value },
          Scheme: { value: "" },
          Amount: { value: "" },
          EUIN: "",
          "SIP Day": { value: "" },
          Frequency: { value: "" },
          "Lumpsum Amount": { value: "" },
          "SIP Period From": { value: "" },
          "SIP Period To": { value: "" },
          "No of Installments": { value: "" },
        });
        break;
      case "No of Installments":
        if (
          !!value &&
          parseInt(value) < parseInt(formValues.MinimumInstallements)
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Number of installments should be greater than or equal to the minimum number of installments ",
            },
          });
        } else if (parseInt(value) > 999) {
          setFormValues({
            [label]: {
              value: "",
              isError: true,
              errorMessage: "No of Installments should not be greater than 999",
            },
          });
        }
        break;
        case "Mode of Registration":
        if (value === "KOTM") {
          fetchUMRNList("KOTM");
        }
        if (value === "AOTM") {
          fetchUMRNList("AOTM");
        } else {
          setFormValues({
            UMRN: { value: "" },
          });
        }
        setFormValues({ [label]: { value } });
        break;
      case "Amount":
        if (!!value && parseInt(value) < parseInt(formValues.MinimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.MinimumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiple) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiple,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        break;
      case "Lumpsum Amount":
        if (
          !!value &&
          parseInt(formValues.MinimumLumpsumAmount) > parseInt(value)
        ) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.MinimumLumpsumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiple) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiple,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        break;
      case "Sub Broker Code":
          if(!!value && `ARN-${value}`===props.token){
            setFormValues({
              [label]: {
                value,
                isError: true,
                errorMessage:
                  "Sub Broker Code and ARN code should not be same",
              },
            });
          }
          else{
            setFormValues({ [label]: { value } });
          }
          break
      case "Sub ARN Code":
          if(!!value &&`ARN-${value}`===props.token){
            setFormValues({
              [label]: {
                value,
                isError: true,
                errorMessage:
                  "Sub ARN Code and ARN code should not be same",
              },
            });
          }
          else{
            setFormValues({ [label]: { value } });
          }
          break
          default:
        setFormValues({ [label]: { value } });
        break;
    }
  };
  const fetchUMRNList = async (type) => {
    setIsLoading(true);
    const { AMC } = formValues;
    const params = {
      Fund: "189",
      PAN: props.applicantparams.i_pangno,
      Acno: 0,
    };
    const response =
      type === "KOTM"
        ? await props.getCheckPanKotm(params)
        : await props.getCheckPanAotm(params);
    const { Table1 } = response;
    const umrnList = Table1.map((item) => ({
      value: item,
      label: item.UMRNNO,
    }));
    if (umrnList.length > 1) {
      const maxAmt = Table1.reduce(
        (max, obj) => (obj.Amt > max ? obj.Amt : max),
        0
      );
      const filteredData = Table1.filter((obj) => obj.Amt === maxAmt);
      setFormValues({ UMRN: { value: filteredData[0] } });
    }
    if (umrnList.length === 1) {
      setFormValues({ UMRN: { value: umrnList[0].value } });
    }
    setFormValues({ umrnList: umrnList });
    setIsLoading(false);
  };
  const getSipDates = async (installments) => {
    const StartDate = formValues["SIP Day"].value;
    const sipDateParams = {
      fund: "189",
      trtype: "SIP",
      StartDate,
      Installments: installments,
      Frequency: formValues.Frequency.value,
      modeofregistration:formValues["Mode of Registration"].value,
    };
    try {
      setIsLoading(true);
      const sipDateResponse = await props.CalcSIPEnddt(sipDateParams);
      const {
        DtData: [dates],
      } = sipDateResponse;
      const { SIP_EndDate, SIP_StartDate } = dates;
      const End_dt = !!SIP_EndDate ? SIP_EndDate.split("/") : [];
      const Start_dt = !!SIP_StartDate ? SIP_StartDate.split("/") : [];
      setFormValues({
        "SIP Period From": {
          value: !!End_dt
            ? new Date().setFullYear(Start_dt[2], Start_dt[1] - 1, Start_dt[0])
            : "",
        },
        "SIP Period To": {
          value: !!Start_dt
            ? new Date().setFullYear(End_dt[2], End_dt[1] - 1, End_dt[0])
            : "",
        },
      });
    } catch (e) {
      console.log("error", e);
      setFormValues({
        "No of Installments": {
          value: "",
          isError: true,
          errorMessage: `Enter Valid Number of Installments`,
        },
        "SIP Period From": { value: "" },
        "SIP Period To": { value: "" },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const validate = (label) => async (event) => {
    const value = event.target.value;
    switch (label) {
      case "Amount":
        if (!!value && parseInt(value) < parseInt(formValues.MinimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to Minimum Amount ",
            },
          });
        }
        break;
      case "No of Installments":
        if (!value && formValues.perpetualSip) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage: `${label} is Mandatory`,
            },
          });
          return;
        }
        getSipDates(value);
        break;
      default:
        break;
    }
  };

  const getMinInstallment = async (event) => {
    const value = event.target.value;
    const { frequencyList } = formValues;

    const installment = frequencyList.find((item) => item.value === value);
    const frequencyParams = {
      opt: SIP_DAY,
      fund: "189",
      astscheme: value,
    };
    const frequencyResponse = await props.swpOptions(frequencyParams);
    const frequencyData = frequencyResponse.Dtinformation;
    const sipDateList = frequencyData.map((item) => ({
      label: item.sip_cycleid,
      value: item.sip_cycleid,
    }));
    setFormValues({
      sipDateList,
      MinimumInstallements: installment.min,
      Frequency: { value },
    });
  };
  const fetchSchemeList = async () => {
    try {
      setIsLoading(true);
      const schemeParams = {
        schtype: "Regular",
        category: formValues.Category.value,
        acno: "0",
        fundCode: "189",
        trantype: "I",
      };
      const schemeResponse = await props.getOtherSchemes(schemeParams);
      const { DtData } = schemeResponse;
      const schemeList = DtData.map((item) => {
        return {
          label: item.fm_schdesc,
          value: item.fm_scheme,
          planValue: item.fm_plan,
          optionValue: item.fm_option,
          schemeValue: item.fm_scheme,
          MinimumAmount: item.SIPminamt,
          multiples: item.multiples,
          MinimumLumpsumAmount: item.fm_newpur,
        };
      });
      setFormValues({
        schemeList,
      });
    } catch (e) {
      console.log(e);
      setFormValues({ schemeList: [] });
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEuinList = async () => {
    try {
      setIsLoading(true);
      const response = await props.validateSubBroker({
        Fund: "189",
        SubAgentCd: "ARN-"+formValues["Sub ARN Code"].value || "",
        AgentCd: props.token,
      });
      const { DtData } = response;
      const euinList = DtData.map((item) => ({
        value: item.abm_name,
        label: item.abm_agent,
      }));
      setFormValues({ euinList: euinList });
    } catch (e) {
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchModelist = async () => {
    try {
      setIsLoading(true);
      const params = {
        opt: PAYMENT_MODE,
        Fund: "189",
        astscheme: props.applicantparams.i_pangno,
      };
      const response = await props.swpOptions(params);
      if (!!response) {
        setFormValues({
          modeList: response.Dtinformation.map((item) => {
            return { label: item.Pay_Mode, value: item.Pay_Mode_Val };
          }),
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCategoryList = async () => {
    try {
      setIsLoading(true);
      let params = { plntype: REGULAR };
      params = { ...params, opt: "AT", fund: "189" };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      const response = await props.getNewPurchaseFundList(params, types);
      const { Dtinformation } = response;
      const categoryList = Dtinformation.map((item) => ({
        value: item.fm_subcategory,
        label: item.fm_subcategory,
      }));
      setFormValues({ CategoryList: categoryList });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchCategoryList();
    fetchModelist();
  }, []);
  useEffect(() => {
    fetchSchemeList();
    fetchEuinList();
  }, [formValues.Category.value]);
  useEffect(() => {
    const handler= setTimeout(() => {
      if(!formValues["Sub ARN Code"].isError){
        fetchEuinList()
      }
    },1000)
    return ()=> clearTimeout(handler);
  },[formValues["Sub ARN Code"].value]); 
  useEffect(() => {
    if (formValues["No of Installments"].value && SIP_Date && Frequency) {
      getSipDates(formValues["No of Installments"].value);
    }
  }, [SIP_Date, Frequency]);
  const handlechangeSIPEndDateChange = () => {
    const { perpetualSip } = formValues;
    let Umrn_endDate;
    const URMN_enddate= formValues["UMRN"]?.value["MANDATE END DATE"]?.split("/")
    const End_dt = "31/12/2099".split("/");
    const endDate = new Date().setFullYear(End_dt[2], End_dt[1] - 1, End_dt[0]);
    if(formValues["UMRN"]?.value["MANDATE END DATE"]){
     Umrn_endDate = new Date().setFullYear(URMN_enddate[2], URMN_enddate[1] - 1, URMN_enddate[0]);
    }
    if (!perpetualSip && formValues["UMRN"]?.value) {
      setFormValues({
        perpetualSip: !perpetualSip,
        "SIP Period To": {
          value:formValues["Mode of Registration"].value==="KOTM"?Umrn_endDate:endDate,
        },
        "No of Installments": {
          value: "",
        },
      });
    }  else if (!perpetualSip ) {
      setFormValues({
        perpetualSip: !perpetualSip,
        "SIP Period To": {
          value:endDate,
        },
        "No of Installments": {
          value: "",
        },
      });
    }else if (!!perpetualSip) {
      setFormValues({
        perpetualSip: !perpetualSip,
      });
    }
  };
  const closeModel = () => {
    history.replace("/new-transaction");
  };
  const gotoTransactionTypes = () => {
    history.replace("/");
  };
  const dispatch = useDispatch();

  const submit = async () => {
    const {
      schemeList,
      euinList,
      CategoryList,
      modeList,
      sipDateList,
      frequencyList,
      MinimumInstallements,
      MinimumAmount,
      MinimumLumpsumAmount,
      planValue,
      optionValue,
      schemeValue,
      type,
      ct,
      umrnList,
      perpetualSip,
      multiple,
      EUIN,
      ...others
    } = formValues;
    let d1, d2
    const split_enddate = format(formValues["SIP Period To"].value, "MM/dd/yyyy").split("/")
    const split_mandatedate = formValues["UMRN"].value["MANDATE END DATE"]?.split("/")
    d1 = new Date(Number(split_enddate[2]), Number(split_enddate[0]) - 1, Number(split_enddate[1]))
    if (formValues["UMRN"].value["MANDATE END DATE"]?.split("/")) {
      d2 = new Date(Number(split_mandatedate[2]), Number(split_mandatedate[1]) - 1, Number(split_mandatedate[0]))
    }
    const noof = ["No of Installments"];
    const umrn = ["UMRN"];
    const subBrokerCodeSubArnCode = ["Sub Broker Code","Sub ARN Code"];

    const values = Object.keys(others);
    const keys =
      values.filter((ele) => ![...noof, ...subBrokerCodeSubArnCode].includes(ele))
      const final_keys_for_validation = formValues["Mode of Registration"].value === "KOTM" ? keys : keys.filter((ele) => !umrn.includes(ele));
      const finalKeysAfterSubARN =
      final_keys_for_validation.filter((ele) => !subBrokerCodeSubArnCode.includes(ele));
      const findError = finalKeysAfterSubARN.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          setFormValues({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${key === "sipType"
                  ? "SIP Type"
                  : key === "Scheme"
                  ? "Scheme"
                  : key === "investmentFrequency"
                  ? "Investment frequency"
                  : key === "installments"
                  ? "Installments"
                  : key === "sipDay"
                  ? "SIP day"
                  : key === "sip_start_date"
                  ? "SIP Start date"
                  : key === "sip_end_date"
                  ? "SIP end date"
                  : key === "installmentAmount"
                  ? "Installment Amount"
                  : key
              } is Mandatory`,
            },
          });
      });

      return;
    } else if (
      others["No of Installments"].value < MinimumInstallements &&
      !formValues.perpetualSip
    ) {
      setFormValues({
        "No of Installments": {
          ...others["No of Installments"],
          isError: true,
          errorMessage: `Number of installments should be greater than or equal to the minimum number of installments`,
        },
      });

      return;
    } else if (parseInt(others["Amount"].value) < parseInt(MinimumAmount)) {
      setFormValues({
        Amount: {
          ...others["Amount"],
          isError: true,
          errorMessage: `Amount should be greater than or equal to Minimum Amount`,
        },
      });

      return;
    } else if (+others["Amount"].value > 1000000) {
      setFormValues({
        Amount: {
          ...others["Amount"],
          isError: true,
          errorMessage: `Amount should be less than or equal to 1,000,000`,
        },
      });
      return;
    } else if (formValues.Amount.value % formValues.multiple !== 0) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage: "Amount should be a multiple of " + formValues.multiple,
        },
      });
      return;
    } else if (
      formValues["Mode of Registration"].value === "KOTM" &&
      formValues["UMRN"].value.Amt < formValues.Amount.value
    ) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage: `SIP installment amount cannot exceed
      mandate registration limit of ${formValues["UMRN"]?.value?.Amt}.`,
        },
      });
    } else if (
      parseInt(others["Lumpsum Amount"].value) <
      parseInt(formValues.MinimumLumpsumAmount)
    ) {
      setFormValues({
        "Lumpsum Amount": {
          ...others["Lumpsum Amount"],
          isError: true,
          errorMessage: `Amount should be greater than or equal to Minimum Amount`,
        },
      });
      return;
    } else if (others["Lumpsum Amount"].value % formValues.multiple !== 0) {
      setFormValues({
        "Lumpsum Amount": {
          value: formValues["Lumpsum Amount"].value,
          isError: true,
          errorMessage: "Amount should be a multiple of " + formValues.multiple,
        },
      });
      return;
    } else if (!isChecked) {
      alert("Please accept the terms and conditions to proceed");

      return;
    } else if (!EUIN.value) {
      setFormValues({
        EUIN: {
          value: "",
          isError: true,
          errorMessage: `Please select EUIN`,
        },
      });
    } else if (d1 > d2) {
      setFormValues({
        "SIP Period To": {
          value: "",
          isError: true,
          errorMessage: `SIP end date cannot exceed mandate validity
          date of ${formValues["UMRN"].value["MANDATE END DATE"]}.`,
        },
      });
      return;
    }
    else if(`ARN-${formValues["Sub Broker Code"]?.value}`===props.token){
      setFormValues({
        "Sub Broker Code": {
          value: formValues["Sub Broker Code"].value,
          isError: true,
          errorMessage:
            "Sub Broker Code and ARN code should not be same",
        },
      });
      return;
    }
    else if(`ARN-${formValues["Sub ARN Code"]?.value}`===props.token){
      setFormValues({
        "Sub ARN Code": {
          value: formValues["Sub ARN Code"].value,
          isError: true,
          errorMessage:
            "Sub ARN Code and ARN code should not be same",
        },
      });
      return;
    }
     else {
      setIsLoading(true);
      const response = await props.PurchaseSaveNominee({
        ...(props.nomineDetails.payload ? props.nomineDetails.payload : {}),
      });
      if(!!response?.Dtinformation[0]?.nom_id ||
        response?.Dtinformation[0]?.nom_id === null){
      const schemedetails = {
        IWishToNominate: props?.nomineDetails?.payload?.IWishToNominate,
        Nomslno:response?.Dtinformation[0]?.nom_id || "",
        i_scheme: schemeValue,
        i_plan: planValue,
        i_option: optionValue,
        sip_amt: others.Amount.value,
        i_disitributorid: props.token,
        i_EUINno: EUIN.value.value,
        i_frequency: others.Frequency.value,
        i_noofinst: others["No of Installments"].value,
        i_sipstartdt: format(others["SIP Period From"].value, "MM/dd/yyyy"),
        i_sipenddt: format(others["SIP Period To"].value, "MM/dd/yyyy"),
        i_amount: formValues["Lumpsum Amount"].value,
        i_paymode: formValues["Mode of Registration"].value,
        i_umrno:formValues["UMRN"]?.value?.UMRNNO,
      };
      const paramsSip = {
        ...props.applicantparams,
        ...props.investmentparams,
        ...props.fatcaDetails,
        ...schemedetails,
        ...props?.nomineDetails?.dotnetApiSubmitKeys,
        i_subBrokerCode:!!formValues["Sub Broker Code"].value ? formValues["Sub Broker Code"].value  : "",
        i_trtype: "SIN",
        i_appldt: format(new Date(), "MM/dd/yyyy"),
        i_chqdt: format(new Date(), "MM/dd/yyyy"),
        i_entby: props.userId,
        i_sipflag: "Y",
        Invdistflag: "B",
        CustomFund: "189",
        i_fund: "189",
        i_subarncode:!!formValues["Sub ARN Code"].value ? formValues["Sub ARN Code"].value  : "",
      };
      try{
        const responseSip = await props.submitSipDetails(paramsSip);
        const { DtData } = responseSip;
        const { appno } = DtData[0];
        setIsLoading(false);
        dispatch(clearingFirstTimeInvestorJourney());
        setDialog({ appno: appno, open: true });
      }
      catch(err){
          alert(err)
          setIsLoading(false)
      }
    }
    else{
      alert("Nominee ID is missing. Please check the nominee details.");
      setIsLoading(false);
    }
  }
  };
  return (
    <>
      <CustomLoader display={isLoading} />
      <CardComponent title="Scheme Details">
        <></>
        {InputFields.map((section, index) => (
          <div className="flex" key={index} style={{flexDirection:"column"}}>
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin transaction-details"
                style={
                  {
                  display: field.display ? "none" : "",
                  }
                } key={field.name}
              >
                {field.type === "select" ? (
                  <CustomizedSelect
                    name={field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={
                      field.name === "Frequency"
                        ? getMinInstallment
                        : handleChange(field.name)
                    }
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={field.disabled}
                  >
                    {formValues[field.listName].map((i, index) => (
                      <MenuItem
                        value={field.name === "Scheme" ? i : i.value}
                        key={index}
                      >
                        {i.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                ) : field.type === "Searchselect" ? (
                  <>
                    <div>
                      <div className="input-name input-integrated-label">
                        {field.name === "Scheme" ? "Scheme" : "EUIN Declaration"}
                      </div>
                      <IntegrationReactSelect
                        suggestions={formValues[field.listName].map((i) => ({
                          label: i.label,
                          value: i.value,
                        }))}
                        value={formValues[field.name].value}
                        placeholder={`Select ${field.name}`}
                        handleChange={handleScheme(field.name)}
                        disabled={field.disabled}
                        isError={formValues[field.name].isError}
                        errorMessage={formValues[field.name].errorMessage}
                      />
                    </div>
                    {field.name === "Amount" && (
                      <span>Minimum Amount : ₹ {formValues.minimumAmount}</span>
                    )}
                  </>
                ) : field.type === "date" ? (
                  <>
                    <div
                      className="input-name"
                      style={{ margingBottom: "10px" }}
                    >
                      {field.name}
                    </div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                       InputProps={{ readOnly: true }}
                       required={true}
                       className="selects"
                       value={formValues[field.name].value}
                       format="dd/MM/yyyy"
                       margin="normal"
                       id="mui-pickers-date"
                       disabled={field.disabled}
                       helperText={formValues[field.name].errorMessage}
                       error={formValues[field.name].isError}
                      />
                    </MuiPickersUtilsProvider>
                    {formValues[field.name].isError && <div>{formValues[field.name].errorMessage}</div> }
                  </>
                ) : field.type === "Perpetual" ? (
                  <div>
                    {!!formValues["SIP Day"].value && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          onClick={handlechangeSIPEndDateChange}
                          // value={!!formValues.perpetualSip}
                          checked={!!formValues.perpetualSip}
                        />
                        <div
                          style={{
                            fontFamily: "OpenSans-SemiBold",
                            fontSize: 14,
                          }}
                        >
                          Perpetual SIP
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div >
                    <Input
                      name={field.name === "Amount" ? "SIP Amount" : field.name}
                      // image="/images/nav.png"
                      isMandatory={field.isMandatory}
                      value={formValues[field.name].value}
                      onChange={handleChange(field.name)}
                      placeholder={field.placeholder}
                      onBlur={
                        field.name === "Amount"
                          ? validate("Amount")
                          : field.name === "No of Installments"
                          ? validate("No of Installments")
                          : handleChange(field.name)
                      }
                      type={field.type}
                      isError={formValues[field.name].isError}
                      isShowError={formValues[field.name].isError}
                      errorMessage={formValues[field.name].errorMessage}
                      id={`${field.name}Field`}
                      disabled={field.disabled}
                      onKeyDown={(e) => e.key === "." && e.preventDefault()}
                    />
                    <span
                      style={{
                        fontFamily: "Rubik-Regular",
                        marginTop: "10px",
                      }}
                    >
                      {field.name === "No of Installments"
                        ? `Minimum number of installments : ${formValues.MinimumInstallements}`
                        : field.name === "Amount"
                        ? `Minimum Amount : ${formValues.MinimumAmount}`
                        : field.name === "Lumpsum Amount"
                        ? `Minimum Lumpsum Amount : ${formValues.MinimumLumpsumAmount}`
                        : null}
                    </span>
                  </div>
                )}
                 {formValues["UMRN"]?.value && field.name === "UMRN" && (
                  <div className="redemption-details">
                    <div className="keys">
                      <div>Mandate amount limit</div>
                      <div>Start Date</div>
                      <div>End Date</div>
                      <div>Bank Name</div>
                      <div>Bank Account No</div>
                    </div>
                    <div className="values">
                      <div>
                        {formValues["UMRN"].value ? formValues["UMRN"].value.Amt : ""}
                        (INR)
                      </div>
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["MANDATE START DATE"]
                          : ""}{" "}
                      </div>
                      <div>
                        {formValues["UMRN"].value
                          ? formValues["UMRN"].value["MANDATE END DATE"]
                          : ""}
                      </div>
                      <div>
                        {formValues["UMRN"].value ? formValues["UMRN"].value["BANK NAME"] : ""}
                      </div>{" "}
                      <div>
                        {formValues["UMRN"].value ? formValues["UMRN"].value["BANK A/C NO"] : ""}
                      </div>
                    </div>
                  </div>
                )}
                {formValues["UMRN"]?.value && field.name === "UMRN" && formValues?.umrnList.length === 1 && (
                   <span className="euin-text">The investor has only one active {formValues["Mode of Registration"]?.value} mandate.</span>
                )}

              </div>
            ))}
          </div>
        ))}

        <>
          <Checkbox
            onChange={() => setIsChecked((p) => !p)}
            checked={isChecked}
          />
          <span style={{ fontWeight: 500, fontFamily: "Rubik-Regular" }}>
            I/We have read and understood the contents of the Offer Document(s),
            Load Structure(s) of the respective Scheme(s) and agree to abide by
            the terms, conditions, rules and regulations of the respective
            Scheme(s).
          </span>
        </>
        <Termsandconditions />
      </CardComponent>
      <div className="d-flex justify-content-end">
        <button
          className="new-investor-button  new-investor-active"
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            history.replace("/new-investor-transaction/bank-details")
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          SUBMIT
        </button>
        <CustomizedDialogs
          open={dialog.open}
          refNo={dialog.appno}
          transactName={"Lumpsum + SIP"}
          closeModal={gotoTransactionTypes}
          Transaction={true}
          transactionStatus={closeModel}
        />
      </div>
    </>
  );
};

export default connect(
  ({ authReducer, transactions, newinvestor }) => {
    const { token, userId } = authReducer;
    const { euinList } = transactions;
    const {
      schemeparams,
      schemeDetails,
      applicantparams,
      fatcaDetails,
      investmentparams,
      nomineDetails,
    } = newinvestor;
    return {
      token,
      userId,
      euinList,
      schemeparams,
      schemeDetails,
      applicantparams,
      investmentparams,
      fatcaDetails,
      nomineDetails,
    };
  },
  {
    getNewPurchaseFundList,
    validateSubBroker,
    swpOptions,
    CalcSIPEnddt,
    submitSipDetails,
    storeSchemeDetails,
    storeSchemeParams,
    getOtherSchemes,
    getCheckPanKotm,
    getNav,
    clearingFirstTimeInvestorJourney,
    getCheckPanAotm,
    PurchaseSaveNominee
  }
)(LummpsumSip);
